/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyStockIndents } from 'app/entities/pharmacy-stock-indent/pharmacy-stock-indent.reducer';
import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-stock-indent-item.reducer';

export const PharmacyStockIndentItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyStockIndents = useAppSelector(state => state.pharmacyStockIndent.entities);
  const pharmacyStockIndentItemEntity = useAppSelector(state => state.pharmacyStockIndentItem.entity);
  const loading = useAppSelector(state => state.pharmacyStockIndentItem.loading);
  const updating = useAppSelector(state => state.pharmacyStockIndentItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyStockIndentItem.updateSuccess);
  const pharmacyIndentStatusValues = Object.keys(PharmacyIndentStatus);
  const pharmacyProductTypeValues = Object.keys(PharmacyProductType);

  const handleClose = () => {
    navigate(`/pharmacy-stock-indent-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyStockIndents({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.indentedQty !== undefined && typeof values.indentedQty !== 'number') {
      values.indentedQty = Number(values.indentedQty);
    }
    if (values.fulfilledQty !== undefined && typeof values.fulfilledQty !== 'number') {
      values.fulfilledQty = Number(values.fulfilledQty);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyStockIndentItemEntity,
      ...values,
      indent: pharmacyStockIndents.find(it => it.id.toString() === values.indent?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          indentStatus: 'REQUESTED',
          productType: 'CONSUMABLE',
          ...pharmacyStockIndentItemEntity,
          indent: pharmacyStockIndentItemEntity?.indent?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyStockIndentItem.home.createOrEditLabel" data-cy="PharmacyStockIndentItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.home.createOrEditLabel">
              Create or edit a PharmacyStockIndentItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-stock-indent-item-id"
                  label={translate('tinyMedicRestApp.pharmacyStockIndentItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.indentStatus')}
                id="pharmacy-stock-indent-item-indentStatus"
                name="indentStatus"
                data-cy="indentStatus"
                type="select"
              >
                {pharmacyIndentStatusValues.map(pharmacyIndentStatus => (
                  <option value={pharmacyIndentStatus} key={pharmacyIndentStatus}>
                    {translate(`tinyMedicRestApp.PharmacyIndentStatus.${pharmacyIndentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.indentedQty')}
                id="pharmacy-stock-indent-item-indentedQty"
                name="indentedQty"
                data-cy="indentedQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.fulfilledQty')}
                id="pharmacy-stock-indent-item-fulfilledQty"
                name="fulfilledQty"
                data-cy="fulfilledQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.packs')}
                id="pharmacy-stock-indent-item-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.productType')}
                id="pharmacy-stock-indent-item-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {pharmacyProductTypeValues.map(pharmacyProductType => (
                  <option value={pharmacyProductType} key={pharmacyProductType}>
                    {translate(`tinyMedicRestApp.PharmacyProductType.${pharmacyProductType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.productId')}
                id="pharmacy-stock-indent-item-productId"
                name="productId"
                data-cy="productId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.active')}
                id="pharmacy-stock-indent-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.cursor')}
                id="pharmacy-stock-indent-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.lastUpdated')}
                id="pharmacy-stock-indent-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.microSec')}
                id="pharmacy-stock-indent-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.timestampEntry')}
                id="pharmacy-stock-indent-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-stock-indent-item-indent"
                name="indent"
                data-cy="indent"
                label={translate('tinyMedicRestApp.pharmacyStockIndentItem.indent')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyStockIndents
                  ? pharmacyStockIndents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-stock-indent-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyStockIndentItemUpdate;
